<div class="mt-4">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" disabled>Factures</button></li>
  </ol>
</div>


<div class="my-3 p-3 bg-white rounded shadow-sm">
  <div class="input-group mb-4">
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
    </div>
    <input type="text" class="form-control" placeholder="Recherche" [(ngModel)]="searchRequest.query" (keyup)="querySearch()"/>

    <supplier-search-criteria class="input-group-append"></supplier-search-criteria>
  </div>

  <div class="btn-toolbar">
    <div class="input-group pr-2 pb-2" *ngIf="searchRequest.getValues('supplier').length > 0">
      <div class="input-group-prepend">
        <div class="btn btn-secondary btn-sm">{{ displaySupplierFilter() }}</div>
      </div>
      <div class="input-group-append">
        <button class="btn btn-secondary btn-sm" type="button" (click)="clearSupplier()" >X</button>
      </div>
    </div>
  </div>

  <div class="border-bottom"></div>
  
  <search-paging [searchComponent]="this"></search-paging>

  <table class="table table-sm" *ngIf="results">
    <thead>
      <tr>
        <th>Fournisseur</th>
        <th>Numéro</th>
        <th>Type</th>
        <th>Références</th>
        <th>Dates</th>
        <th>Status</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let invoice of results.content">
        <td>{{ invoice.supplier.name }}</td>
        <td>{{ invoice.supplierInvoiceNumber }}</td>
        <td>
          <invoice-type [invoiceType]="invoice.type"></invoice-type>
        </td>
        <td>{{ invoice.references }}</td>
        <td>
          <div>Facture reçu le <strong>{{ invoice.creationTimestamp | date: 'medium' }}</strong></div>
          <div *ngIf="invoice.receivedTimestamp">Réceptionné le <strong>{{ invoice.receivedTimestamp | date: 'medium' }}</strong></div>
        </td>
        <td>
          <invoice-status [status]="invoice.status"></invoice-status>
        </td>
        <td>
          <button class="btn btn-sm btn-outline-primary m-2" (click)="openInvoice(invoice)"><span class="bi bi-file-text"></span></button>
        </td>
      </tr>
    </thead>
  </table>

  <search-paging [searchComponent]="this"></search-paging>
</div>